export enum RequestType {
    Payment = "Payment",
    ExpectFunds = "ExpectFunds",
    TransferFund = "TransferFund",
    Journal = "Journal"
}

export const RequestTypeOrder: Record<RequestType, number> = {
    [RequestType.Payment]: 1,
    [RequestType.ExpectFunds]: 2,
    [RequestType.TransferFund]: 3,
    [RequestType.Journal]: 4
}
